import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(0);

  const faqs = [
    {
      category: "Bewerbung & Qualifikation",
      questions: [
        {
          question: "Welche Qualifikationen benötige ich für eine Bewerbung?",
          answer: `Sie benötigen ein abgeschlossenes Jurastudium mit beiden Staatsexamina und eine Zulassung als Rechtsanwalt in Deutschland. Auch Berufsanfänger sind herzlich willkommen.\n\nZusätzlich sollten Sie über exzellente Kommunikationsfähigkeiten verfügen und Interesse an der Mandantenberatung haben.`
        },
        {
          question: "Kann ich mich auch als Berufsanfänger bewerben?",
          answer: `Ja, absolut! Wir heißen Berufsanfänger herzlich willkommen und bieten umfassende Unterstützung beim Einstieg in die telefonische Rechtsberatung.\n\nWir bieten umfassende Einarbeitungsprogramme und Mentoring für alle neuen Kollegen, unabhängig von der Berufserfahrung.`
        },
        {
          question: "Welche Rechtsgebiete werden bei AdvoCall abgedeckt?",
          answer: `Wir decken alle wichtigen Rechtsgebiete ab: Zivilrecht, Strafrecht, Arbeitsrecht, Familienrecht, Handelsrecht, Immobilienrecht, Urheberrecht, Steuerrecht und Verwaltungsrecht.\n\nBesonders gesucht sind Spezialisten in den Bereichen Arbeitsrecht, Mietrecht und Vertragsrecht.`
        }
      ]
    },
    {
      category: "Arbeitskonditionen",
      questions: [
        {
          question: "Wie flexibel sind die Arbeitszeiten?",
          answer: `Sie bestimmen Ihre Arbeitszeiten vollständig selbst. Unser Service läuft 24/7, Sie können sich aber Ihre Schichten frei einteilen.\n\nViele unserer Anwälte arbeiten in Teilzeit oder haben individuelle Arbeitsmodelle, die perfekt zu ihrem Lebensstil passen.`
        },
        {
          question: "Kann ich von zu Hause arbeiten?",
          answer: `Ja, Sie können vollständig im Home Office arbeiten. Sie benötigen lediglich eine stabile Internetverbindung und einen ruhigen Arbeitsplatz.\n\nWir stellen Ihnen die gesamte technische Ausstattung zur Verfügung, die Sie für die telefonische Beratung benötigen.`
        },
        {
          question: "Wie hoch ist die Vergütung?",
          answer: `Die Vergütung liegt zwischen 45-75€ pro Stunde, abhängig von Ihrer Erfahrung und Spezialisierung. Zusätzlich gibt es Leistungsboni und weitere Benefits.\n\nDie Abrechnung erfolgt transparent und pünktlich monatlich. Zusätzlich bieten wir eine betriebliche Altersvorsorge.`
        }
      ]
    },
    {
      category: "Technologie & Support",
      questions: [
        {
          question: "Welche technische Ausstattung benötige ich?",
          answer: `Sie benötigen einen modernen Computer/Laptop, eine stabile Internetverbindung (min. 50 Mbit/s) und ein ruhiges Arbeitsumfeld.\n\nWir stellen Ihnen ein professionelles Headset, Zugang zu unserer Software und alle notwendigen Tools zur Verfügung.`
        },
        {
          question: "Wie funktioniert die telefonische Beratung?",
          answer: `Mandanten rufen über unsere Hotline an und werden basierend auf ihrem Anliegen an den passenden Anwalt weitergeleitet. Sie erhalten alle relevanten Informationen vor dem Gespräch.\n\nUnsere Software unterstützt Sie mit Vorlagen, Rechtsdatenbanken und automatischer Dokumentation.`
        },
        {
          question: "Welche Unterstützung erhalte ich bei komplexen Fällen?",
          answer: `Sie haben jederzeit Zugang zu unserem internen Expertennetzwerk. Bei komplexen Fällen können Sie sich mit Kollegen austauschen oder Fälle eskalieren.\n\nZusätzlich haben Sie Zugang zu allen wichtigen Rechtsdatenbanken und Fachliteratur.`
        }
      ]
    }
  ];

  const toggleFAQ = (categoryIndex, questionIndex) => {
    const faqIndex = categoryIndex * 100 + questionIndex;
    setOpenFAQ(openFAQ === faqIndex ? -1 : faqIndex);
  };

  return (
    <section className="py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl lg:text-4xl font-bold text-text-primary mb-4">
            Häufig gestellte Fragen
          </h2>
          <p className="text-xl text-text-secondary max-w-3xl mx-auto">
            Hier finden Sie Antworten auf die wichtigsten Fragen rund um eine Karriere bei AdvoCall
          </p>
        </div>

        <div className="space-y-8">
          {faqs?.map((category, categoryIndex) => (
            <div key={categoryIndex} className="bg-surface rounded-2xl p-6 lg:p-8">
              <h3 className="text-xl font-bold text-text-primary mb-6 flex items-center space-x-3">
                <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
                  <Icon name="HelpCircle" size={20} color="white" />
                </div>
                <span>{category?.category}</span>
              </h3>

              <div className="space-y-4">
                {category?.questions?.map((faq, questionIndex) => {
                  const faqIndex = categoryIndex * 100 + questionIndex;
                  const isOpen = openFAQ === faqIndex;

                  return (
                    <div
                      key={questionIndex}
                      className="bg-white rounded-xl border border-slate-200 overflow-hidden hover:shadow-professional transition-shadow duration-200"
                    >
                      <button
                        onClick={() => toggleFAQ(categoryIndex, questionIndex)}
                        className="w-full px-6 py-4 text-left flex items-center justify-between hover:bg-slate-50 transition-colors duration-200"
                      >
                        <span className="text-text-primary font-medium pr-4">
                          {faq?.question}
                        </span>
                        <div className={`transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`}>
                          <Icon name="ChevronDown" size={20} color="var(--color-text-secondary)" />
                        </div>
                      </button>
                      {isOpen && (
                        <div className="px-6 pb-4 border-t border-slate-100">
                          <div className="pt-4 text-text-secondary leading-relaxed">
                            {faq?.answer?.split('\n\n')?.map((paragraph, index) => (
                              <p key={index} className={index > 0 ? 'mt-4' : ''}>
                                {paragraph}
                              </p>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 bg-gradient-to-r from-primary to-accent rounded-2xl p-8 lg:p-12 text-white text-center">
          <Icon name="MessageCircle" size={48} color="white" className="mx-auto mb-6" />
          <h3 className="text-2xl lg:text-3xl font-bold mb-4">
            Weitere Fragen?
          </h3>
          <p className="text-lg text-white/90 mb-8 max-w-2xl mx-auto">
            Unser HR-Team steht Ihnen gerne für alle weiteren Fragen zur Verfügung. Kontaktieren Sie uns telefonisch oder per E-Mail.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
              <Icon name="Phone" size={20} />
              <div className="text-left">
                <div className="font-semibold">09001000312</div>
                <div className="text-sm text-white/80">Mo-Fr 9:00-18:00</div>
              </div>
            </div>
            
            <div className="flex items-center space-x-3 bg-white/10 backdrop-blur-sm rounded-lg px-6 py-3">
              <Icon name="Mail" size={20} />
              <div className="text-left">
                <div className="font-semibold">karriere@advocall.de</div>
                <div className="text-sm text-white/80">Antwort binnen 24h</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;